/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb = require('../../../../../../github.com/solo-io/dev-portal/api/dev-portal/v1beta1/common/common_pb.js');
var github_com_solo$io_dev$portal_api_dev$portal_v1beta1_route_pb = require('../../../../../../github.com/solo-io/dev-portal/api/dev-portal/v1beta1/route_pb.js');
var github_com_solo$io_cue_encoding_protobuf_cue_cue_pb = require('../../../../../../github.com/solo-io/cue/encoding/protobuf/cue/cue_pb.js');
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
var extproto_ext_pb = require('../../../../../../extproto/ext_pb.js');
goog.exportSymbol('proto.portal.gloo.solo.io.APIProductSpec', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.APIProductSpec.APISelector', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.APIProductSpec.Version', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.APIProductStatus', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.APIRoute', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.APIType', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.GatewayConfig', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.GrpcMethodSelector', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.OpenAPIOperationSelector', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.APIProductSpec = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.portal.gloo.solo.io.APIProductSpec.repeatedFields_, null);
};
goog.inherits(proto.portal.gloo.solo.io.APIProductSpec, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.APIProductSpec.displayName = 'proto.portal.gloo.solo.io.APIProductSpec';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.portal.gloo.solo.io.APIProductSpec.repeatedFields_ = [2,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.APIProductSpec.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.APIProductSpec.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.APIProductSpec} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductSpec.toObject = function(includeInstance, msg) {
  var f, obj = {
    displayInfo: (f = msg.getDisplayInfo()) && proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.toObject(includeInstance, f),
    usagePlansList: jspb.Message.getRepeatedField(msg, 2),
    versionsList: jspb.Message.toObjectList(msg.getVersionsList(),
    proto.portal.gloo.solo.io.APIProductSpec.Version.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.APIProductSpec}
 */
proto.portal.gloo.solo.io.APIProductSpec.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.APIProductSpec;
  return proto.portal.gloo.solo.io.APIProductSpec.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.APIProductSpec} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.APIProductSpec}
 */
proto.portal.gloo.solo.io.APIProductSpec.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo;
      reader.readMessage(value,proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.deserializeBinaryFromReader);
      msg.setDisplayInfo(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addUsagePlans(value);
      break;
    case 8:
      var value = new proto.portal.gloo.solo.io.APIProductSpec.Version;
      reader.readMessage(value,proto.portal.gloo.solo.io.APIProductSpec.Version.deserializeBinaryFromReader);
      msg.addVersions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.APIProductSpec.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.APIProductSpec.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.APIProductSpec} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductSpec.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.serializeBinaryToWriter
    );
  }
  f = message.getUsagePlansList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getVersionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.portal.gloo.solo.io.APIProductSpec.Version.serializeBinaryToWriter
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.APIProductSpec.Version = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.portal.gloo.solo.io.APIProductSpec.Version.repeatedFields_, null);
};
goog.inherits(proto.portal.gloo.solo.io.APIProductSpec.Version, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.APIProductSpec.Version.displayName = 'proto.portal.gloo.solo.io.APIProductSpec.Version';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.APIProductSpec.Version.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.Version} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    apisList: jspb.Message.toObjectList(msg.getApisList(),
    proto.portal.gloo.solo.io.APIProductSpec.APISelector.toObject, includeInstance),
    tagsMap: (f = msg.getTagsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Empty.toObject) : [],
    gatewayConfig: (f = msg.getGatewayConfig()) && proto.portal.gloo.solo.io.GatewayConfig.toObject(includeInstance, f),
    customRouteTable: (f = msg.getCustomRouteTable()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.APIProductSpec.Version}
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.APIProductSpec.Version;
  return proto.portal.gloo.solo.io.APIProductSpec.Version.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.Version} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.APIProductSpec.Version}
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = new proto.portal.gloo.solo.io.APIProductSpec.APISelector;
      reader.readMessage(value,proto.portal.gloo.solo.io.APIProductSpec.APISelector.deserializeBinaryFromReader);
      msg.addApis(value);
      break;
    case 7:
      var value = msg.getTagsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Empty.deserializeBinaryFromReader, "");
         });
      break;
    case 8:
      var value = new proto.portal.gloo.solo.io.GatewayConfig;
      reader.readMessage(value,proto.portal.gloo.solo.io.GatewayConfig.deserializeBinaryFromReader);
      msg.setGatewayConfig(value);
      break;
    case 9:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.setCustomRouteTable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.APIProductSpec.Version.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.Version} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getApisList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.portal.gloo.solo.io.APIProductSpec.APISelector.serializeBinaryToWriter
    );
  }
  f = message.getTagsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Empty.serializeBinaryToWriter);
  }
  f = message.getGatewayConfig();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.portal.gloo.solo.io.GatewayConfig.serializeBinaryToWriter
    );
  }
  f = message.getCustomRouteTable();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated APISelector apis = 5;
 * @return {!Array<!proto.portal.gloo.solo.io.APIProductSpec.APISelector>}
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.getApisList = function() {
  return /** @type{!Array<!proto.portal.gloo.solo.io.APIProductSpec.APISelector>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.portal.gloo.solo.io.APIProductSpec.APISelector, 5));
};


/** @param {!Array<!proto.portal.gloo.solo.io.APIProductSpec.APISelector>} value */
proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.setApisList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.APISelector=} opt_value
 * @param {number=} opt_index
 * @return {!proto.portal.gloo.solo.io.APIProductSpec.APISelector}
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.addApis = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.portal.gloo.solo.io.APIProductSpec.APISelector, opt_index);
};


proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.clearApisList = function() {
  this.setApisList([]);
};


/**
 * map<string, google.protobuf.Empty> tags = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Empty>}
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.getTagsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Empty>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      proto.google.protobuf.Empty));
};


proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.clearTagsMap = function() {
  this.getTagsMap().clear();
};


/**
 * optional GatewayConfig gateway_config = 8;
 * @return {?proto.portal.gloo.solo.io.GatewayConfig}
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.getGatewayConfig = function() {
  return /** @type{?proto.portal.gloo.solo.io.GatewayConfig} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.GatewayConfig, 8));
};


/** @param {?proto.portal.gloo.solo.io.GatewayConfig|undefined} value */
proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.setGatewayConfig = function(value) {
  jspb.Message.setWrapperField(this, 8, value);
};


proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.clearGatewayConfig = function() {
  this.setGatewayConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.hasGatewayConfig = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional common.portal.gloo.solo.io.ObjectRef custom_route_table = 9;
 * @return {?proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.getCustomRouteTable = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 9));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectRef|undefined} value */
proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.setCustomRouteTable = function(value) {
  jspb.Message.setWrapperField(this, 9, value);
};


proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.clearCustomRouteTable = function() {
  this.setCustomRouteTable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIProductSpec.Version.prototype.hasCustomRouteTable = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.displayName = 'proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    termsofservice: jspb.Message.getFieldWithDefault(msg, 3, ""),
    contact: (f = msg.getContact()) && proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.toObject(includeInstance, f),
    license: (f = msg.getLicense()) && proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.toObject(includeInstance, f),
    image: (f = msg.getImage()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo;
  return proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTermsofservice(value);
      break;
    case 4:
      var value = new proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact;
      reader.readMessage(value,proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.deserializeBinaryFromReader);
      msg.setContact(value);
      break;
    case 5:
      var value = new proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License;
      reader.readMessage(value,proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.deserializeBinaryFromReader);
      msg.setLicense(value);
      break;
    case 7:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTermsofservice();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContact();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.serializeBinaryToWriter
    );
  }
  f = message.getLicense();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.serializeBinaryToWriter
    );
  }
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.serializeBinaryToWriter
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.displayName = 'proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    url: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact;
  return proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.prototype.setUrl = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.displayName = 'proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    url: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License;
  return proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License.prototype.setUrl = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.setTitle = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string termsOfService = 3;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.getTermsofservice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.setTermsofservice = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Contact contact = 4;
 * @return {?proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.getContact = function() {
  return /** @type{?proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact, 4));
};


/** @param {?proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.Contact|undefined} value */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.setContact = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.clearContact = function() {
  this.setContact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.hasContact = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional License license = 5;
 * @return {?proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.getLicense = function() {
  return /** @type{?proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License, 5));
};


/** @param {?proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.License|undefined} value */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.setLicense = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.clearLicense = function() {
  this.setLicense(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.hasLicense = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional common.portal.gloo.solo.io.DataSource image = 7;
 * @return {?proto.common.portal.gloo.solo.io.DataSource}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.getImage = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.DataSource} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource, 7));
};


/** @param {?proto.common.portal.gloo.solo.io.DataSource|undefined} value */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.setImage = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.clearImage = function() {
  this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo.prototype.hasImage = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.portal.gloo.solo.io.APIProductSpec.APISelector.oneofGroups_);
};
goog.inherits(proto.portal.gloo.solo.io.APIProductSpec.APISelector, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.APIProductSpec.APISelector.displayName = 'proto.portal.gloo.solo.io.APIProductSpec.APISelector';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.OperationsCase = {
  OPERATIONS_NOT_SET: 0,
  OPEN_API: 2,
  GRPC: 3
};

/**
 * @return {proto.portal.gloo.solo.io.APIProductSpec.APISelector.OperationsCase}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.getOperationsCase = function() {
  return /** @type {proto.portal.gloo.solo.io.APIProductSpec.APISelector.OperationsCase} */(jspb.Message.computeOneofCase(this, proto.portal.gloo.solo.io.APIProductSpec.APISelector.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.APIProductSpec.APISelector.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.APISelector} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.toObject = function(includeInstance, msg) {
  var f, obj = {
    apidoc: (f = msg.getApidoc()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject(includeInstance, f),
    openApi: (f = msg.getOpenApi()) && proto.portal.gloo.solo.io.OpenAPIOperationSelector.toObject(includeInstance, f),
    grpc: (f = msg.getGrpc()) && proto.portal.gloo.solo.io.GrpcMethodSelector.toObject(includeInstance, f),
    gatewayConfig: (f = msg.getGatewayConfig()) && proto.portal.gloo.solo.io.GatewayConfig.toObject(includeInstance, f),
    includeUnlistedOperations: (f = msg.getIncludeUnlistedOperations()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.APIProductSpec.APISelector}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.APIProductSpec.APISelector;
  return proto.portal.gloo.solo.io.APIProductSpec.APISelector.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.APISelector} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.APIProductSpec.APISelector}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.setApidoc(value);
      break;
    case 2:
      var value = new proto.portal.gloo.solo.io.OpenAPIOperationSelector;
      reader.readMessage(value,proto.portal.gloo.solo.io.OpenAPIOperationSelector.deserializeBinaryFromReader);
      msg.setOpenApi(value);
      break;
    case 3:
      var value = new proto.portal.gloo.solo.io.GrpcMethodSelector;
      reader.readMessage(value,proto.portal.gloo.solo.io.GrpcMethodSelector.deserializeBinaryFromReader);
      msg.setGrpc(value);
      break;
    case 4:
      var value = new proto.portal.gloo.solo.io.GatewayConfig;
      reader.readMessage(value,proto.portal.gloo.solo.io.GatewayConfig.deserializeBinaryFromReader);
      msg.setGatewayConfig(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIncludeUnlistedOperations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.APIProductSpec.APISelector.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.APISelector} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApidoc();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
  f = message.getOpenApi();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.portal.gloo.solo.io.OpenAPIOperationSelector.serializeBinaryToWriter
    );
  }
  f = message.getGrpc();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.portal.gloo.solo.io.GrpcMethodSelector.serializeBinaryToWriter
    );
  }
  f = message.getGatewayConfig();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.portal.gloo.solo.io.GatewayConfig.serializeBinaryToWriter
    );
  }
  f = message.getIncludeUnlistedOperations();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.portal.gloo.solo.io.ObjectRef apiDoc = 1;
 * @return {?proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.getApidoc = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 1));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectRef|undefined} value */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.setApidoc = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.clearApidoc = function() {
  this.setApidoc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.hasApidoc = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OpenAPIOperationSelector open_api = 2;
 * @return {?proto.portal.gloo.solo.io.OpenAPIOperationSelector}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.getOpenApi = function() {
  return /** @type{?proto.portal.gloo.solo.io.OpenAPIOperationSelector} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.OpenAPIOperationSelector, 2));
};


/** @param {?proto.portal.gloo.solo.io.OpenAPIOperationSelector|undefined} value */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.setOpenApi = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.portal.gloo.solo.io.APIProductSpec.APISelector.oneofGroups_[0], value);
};


proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.clearOpenApi = function() {
  this.setOpenApi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.hasOpenApi = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional GrpcMethodSelector grpc = 3;
 * @return {?proto.portal.gloo.solo.io.GrpcMethodSelector}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.getGrpc = function() {
  return /** @type{?proto.portal.gloo.solo.io.GrpcMethodSelector} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.GrpcMethodSelector, 3));
};


/** @param {?proto.portal.gloo.solo.io.GrpcMethodSelector|undefined} value */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.setGrpc = function(value) {
  jspb.Message.setOneofWrapperField(this, 3, proto.portal.gloo.solo.io.APIProductSpec.APISelector.oneofGroups_[0], value);
};


proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.clearGrpc = function() {
  this.setGrpc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.hasGrpc = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional GatewayConfig gateway_config = 4;
 * @return {?proto.portal.gloo.solo.io.GatewayConfig}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.getGatewayConfig = function() {
  return /** @type{?proto.portal.gloo.solo.io.GatewayConfig} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.GatewayConfig, 4));
};


/** @param {?proto.portal.gloo.solo.io.GatewayConfig|undefined} value */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.setGatewayConfig = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.clearGatewayConfig = function() {
  this.setGatewayConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.hasGatewayConfig = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.BoolValue include_unlisted_operations = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.getIncludeUnlistedOperations = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.setIncludeUnlistedOperations = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.clearIncludeUnlistedOperations = function() {
  this.setIncludeUnlistedOperations(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIProductSpec.APISelector.prototype.hasIncludeUnlistedOperations = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional DisplayInfo display_info = 1;
 * @return {?proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo}
 */
proto.portal.gloo.solo.io.APIProductSpec.prototype.getDisplayInfo = function() {
  return /** @type{?proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo, 1));
};


/** @param {?proto.portal.gloo.solo.io.APIProductSpec.DisplayInfo|undefined} value */
proto.portal.gloo.solo.io.APIProductSpec.prototype.setDisplayInfo = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.portal.gloo.solo.io.APIProductSpec.prototype.clearDisplayInfo = function() {
  this.setDisplayInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIProductSpec.prototype.hasDisplayInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated string usage_plans = 2;
 * @return {!Array<string>}
 */
proto.portal.gloo.solo.io.APIProductSpec.prototype.getUsagePlansList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.portal.gloo.solo.io.APIProductSpec.prototype.setUsagePlansList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.portal.gloo.solo.io.APIProductSpec.prototype.addUsagePlans = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


proto.portal.gloo.solo.io.APIProductSpec.prototype.clearUsagePlansList = function() {
  this.setUsagePlansList([]);
};


/**
 * repeated Version versions = 8;
 * @return {!Array<!proto.portal.gloo.solo.io.APIProductSpec.Version>}
 */
proto.portal.gloo.solo.io.APIProductSpec.prototype.getVersionsList = function() {
  return /** @type{!Array<!proto.portal.gloo.solo.io.APIProductSpec.Version>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.portal.gloo.solo.io.APIProductSpec.Version, 8));
};


/** @param {!Array<!proto.portal.gloo.solo.io.APIProductSpec.Version>} value */
proto.portal.gloo.solo.io.APIProductSpec.prototype.setVersionsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.portal.gloo.solo.io.APIProductSpec.Version=} opt_value
 * @param {number=} opt_index
 * @return {!proto.portal.gloo.solo.io.APIProductSpec.Version}
 */
proto.portal.gloo.solo.io.APIProductSpec.prototype.addVersions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.portal.gloo.solo.io.APIProductSpec.Version, opt_index);
};


proto.portal.gloo.solo.io.APIProductSpec.prototype.clearVersionsList = function() {
  this.setVersionsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.portal.gloo.solo.io.OpenAPIOperationSelector.repeatedFields_, null);
};
goog.inherits(proto.portal.gloo.solo.io.OpenAPIOperationSelector, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.OpenAPIOperationSelector.displayName = 'proto.portal.gloo.solo.io.OpenAPIOperationSelector';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.OpenAPIOperationSelector.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.OpenAPIOperationSelector} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.toObject = function(includeInstance, msg) {
  var f, obj = {
    operationsList: jspb.Message.toObjectList(msg.getOperationsList(),
    proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.OpenAPIOperationSelector}
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.OpenAPIOperationSelector;
  return proto.portal.gloo.solo.io.OpenAPIOperationSelector.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.OpenAPIOperationSelector} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.OpenAPIOperationSelector}
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation;
      reader.readMessage(value,proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.deserializeBinaryFromReader);
      msg.addOperations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.OpenAPIOperationSelector.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.OpenAPIOperationSelector} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.serializeBinaryToWriter
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.displayName = 'proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    gatewayConfig: (f = msg.getGatewayConfig()) && proto.portal.gloo.solo.io.GatewayConfig.toObject(includeInstance, f),
    exclude: jspb.Message.getFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation}
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation;
  return proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation}
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.portal.gloo.solo.io.GatewayConfig;
      reader.readMessage(value,proto.portal.gloo.solo.io.GatewayConfig.deserializeBinaryFromReader);
      msg.setGatewayConfig(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExclude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGatewayConfig();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.portal.gloo.solo.io.GatewayConfig.serializeBinaryToWriter
    );
  }
  f = message.getExclude();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.prototype.setId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional GatewayConfig gateway_config = 2;
 * @return {?proto.portal.gloo.solo.io.GatewayConfig}
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.prototype.getGatewayConfig = function() {
  return /** @type{?proto.portal.gloo.solo.io.GatewayConfig} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.GatewayConfig, 2));
};


/** @param {?proto.portal.gloo.solo.io.GatewayConfig|undefined} value */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.prototype.setGatewayConfig = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.prototype.clearGatewayConfig = function() {
  this.setGatewayConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.prototype.hasGatewayConfig = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool exclude = 3;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.prototype.getExclude = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation.prototype.setExclude = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated OpenAPIOperation operations = 1;
 * @return {!Array<!proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation>}
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.prototype.getOperationsList = function() {
  return /** @type{!Array<!proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation, 1));
};


/** @param {!Array<!proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation>} value */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.prototype.setOperationsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation}
 */
proto.portal.gloo.solo.io.OpenAPIOperationSelector.prototype.addOperations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.portal.gloo.solo.io.OpenAPIOperationSelector.OpenAPIOperation, opt_index);
};


proto.portal.gloo.solo.io.OpenAPIOperationSelector.prototype.clearOperationsList = function() {
  this.setOperationsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.GrpcMethodSelector = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.portal.gloo.solo.io.GrpcMethodSelector.repeatedFields_, null);
};
goog.inherits(proto.portal.gloo.solo.io.GrpcMethodSelector, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.GrpcMethodSelector.displayName = 'proto.portal.gloo.solo.io.GrpcMethodSelector';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.GrpcMethodSelector.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.GrpcMethodSelector} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.toObject = function(includeInstance, msg) {
  var f, obj = {
    methodsList: jspb.Message.toObjectList(msg.getMethodsList(),
    proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.GrpcMethodSelector}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.GrpcMethodSelector;
  return proto.portal.gloo.solo.io.GrpcMethodSelector.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.GrpcMethodSelector} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.GrpcMethodSelector}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod;
      reader.readMessage(value,proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.deserializeBinaryFromReader);
      msg.addMethods(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.GrpcMethodSelector.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.GrpcMethodSelector} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMethodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.serializeBinaryToWriter
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.displayName = 'proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rpcName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    gatewayConfig: (f = msg.getGatewayConfig()) && proto.portal.gloo.solo.io.GatewayConfig.toObject(includeInstance, f),
    exclude: jspb.Message.getFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod;
  return proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRpcName(value);
      break;
    case 3:
      var value = new proto.portal.gloo.solo.io.GatewayConfig;
      reader.readMessage(value,proto.portal.gloo.solo.io.GatewayConfig.deserializeBinaryFromReader);
      msg.setGatewayConfig(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExclude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRpcName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGatewayConfig();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.portal.gloo.solo.io.GatewayConfig.serializeBinaryToWriter
    );
  }
  f = message.getExclude();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string service_name = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.prototype.getServiceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.prototype.setServiceName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string rpc_name = 2;
 * @return {string}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.prototype.getRpcName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.prototype.setRpcName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional GatewayConfig gateway_config = 3;
 * @return {?proto.portal.gloo.solo.io.GatewayConfig}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.prototype.getGatewayConfig = function() {
  return /** @type{?proto.portal.gloo.solo.io.GatewayConfig} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.GatewayConfig, 3));
};


/** @param {?proto.portal.gloo.solo.io.GatewayConfig|undefined} value */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.prototype.setGatewayConfig = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.prototype.clearGatewayConfig = function() {
  this.setGatewayConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.prototype.hasGatewayConfig = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool exclude = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.prototype.getExclude = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod.prototype.setExclude = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * repeated GrpcMethod methods = 1;
 * @return {!Array<!proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod>}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.prototype.getMethodsList = function() {
  return /** @type{!Array<!proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod, 1));
};


/** @param {!Array<!proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod>} value */
proto.portal.gloo.solo.io.GrpcMethodSelector.prototype.setMethodsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod}
 */
proto.portal.gloo.solo.io.GrpcMethodSelector.prototype.addMethods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.portal.gloo.solo.io.GrpcMethodSelector.GrpcMethod, opt_index);
};


proto.portal.gloo.solo.io.GrpcMethodSelector.prototype.clearMethodsList = function() {
  this.setMethodsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.GatewayConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.portal.gloo.solo.io.GatewayConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.GatewayConfig.displayName = 'proto.portal.gloo.solo.io.GatewayConfig';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.GatewayConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.GatewayConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.GatewayConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.GatewayConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    route: (f = msg.getRoute()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_route_pb.RouteSpecifier.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.GatewayConfig}
 */
proto.portal.gloo.solo.io.GatewayConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.GatewayConfig;
  return proto.portal.gloo.solo.io.GatewayConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.GatewayConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.GatewayConfig}
 */
proto.portal.gloo.solo.io.GatewayConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_route_pb.RouteSpecifier;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_route_pb.RouteSpecifier.deserializeBinaryFromReader);
      msg.setRoute(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.GatewayConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.GatewayConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.GatewayConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.GatewayConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoute();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_route_pb.RouteSpecifier.serializeBinaryToWriter
    );
  }
};


/**
 * optional RouteSpecifier route = 1;
 * @return {?proto.portal.gloo.solo.io.RouteSpecifier}
 */
proto.portal.gloo.solo.io.GatewayConfig.prototype.getRoute = function() {
  return /** @type{?proto.portal.gloo.solo.io.RouteSpecifier} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_route_pb.RouteSpecifier, 1));
};


/** @param {?proto.portal.gloo.solo.io.RouteSpecifier|undefined} value */
proto.portal.gloo.solo.io.GatewayConfig.prototype.setRoute = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.portal.gloo.solo.io.GatewayConfig.prototype.clearRoute = function() {
  this.setRoute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.GatewayConfig.prototype.hasRoute = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.APIProductStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.portal.gloo.solo.io.APIProductStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.APIProductStatus.displayName = 'proto.portal.gloo.solo.io.APIProductStatus';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.APIProductStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.APIProductStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.APIProductStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    observedGeneration: jspb.Message.getFieldWithDefault(msg, 1, 0),
    state: jspb.Message.getFieldWithDefault(msg, 2, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 3, ""),
    modifiedDate: (f = msg.getModifiedDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    observedLabelsMap: (f = msg.getObservedLabelsMap()) ? f.toObject(includeInstance, undefined) : [],
    versionInfoMap: (f = msg.getVersionInfoMap()) ? f.toObject(includeInstance, proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.APIProductStatus}
 */
proto.portal.gloo.solo.io.APIProductStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.APIProductStatus;
  return proto.portal.gloo.solo.io.APIProductStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.APIProductStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.APIProductStatus}
 */
proto.portal.gloo.solo.io.APIProductStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setObservedGeneration(value);
      break;
    case 2:
      var value = /** @type {!proto.common.portal.gloo.solo.io.State} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setModifiedDate(value);
      break;
    case 5:
      var value = msg.getObservedLabelsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "");
         });
      break;
    case 9:
      var value = msg.getVersionInfoMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.deserializeBinaryFromReader, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.APIProductStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.APIProductStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.APIProductStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObservedGeneration();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getModifiedDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getObservedLabelsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getVersionInfoMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(9, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.serializeBinaryToWriter);
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.repeatedFields_, null);
};
goog.inherits(proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.displayName = 'proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    grpcDescriptors: (f = msg.getGrpcDescriptors()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    apiRoutesList: jspb.Message.toObjectList(msg.getApiRoutesList(),
    proto.portal.gloo.solo.io.APIRoute.toObject, includeInstance),
    numberOfEndpoints: jspb.Message.getFieldWithDefault(msg, 4, 0),
    apiType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    customRouteTable: (f = msg.getCustomRouteTable()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo}
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo;
  return proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo}
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setGrpcDescriptors(value);
      break;
    case 3:
      var value = new proto.portal.gloo.solo.io.APIRoute;
      reader.readMessage(value,proto.portal.gloo.solo.io.APIRoute.deserializeBinaryFromReader);
      msg.addApiRoutes(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfEndpoints(value);
      break;
    case 5:
      var value = /** @type {!proto.portal.gloo.solo.io.APIType} */ (reader.readEnum());
      msg.setApiType(value);
      break;
    case 7:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.setCustomRouteTable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGrpcDescriptors();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getApiRoutesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.portal.gloo.solo.io.APIRoute.serializeBinaryToWriter
    );
  }
  f = message.getNumberOfEndpoints();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getApiType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCustomRouteTable();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Struct grpc_descriptors = 2;
 * @return {?proto.google.protobuf.Struct}
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.getGrpcDescriptors = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 2));
};


/** @param {?proto.google.protobuf.Struct|undefined} value */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.setGrpcDescriptors = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.clearGrpcDescriptors = function() {
  this.setGrpcDescriptors(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.hasGrpcDescriptors = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated APIRoute api_routes = 3;
 * @return {!Array<!proto.portal.gloo.solo.io.APIRoute>}
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.getApiRoutesList = function() {
  return /** @type{!Array<!proto.portal.gloo.solo.io.APIRoute>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.portal.gloo.solo.io.APIRoute, 3));
};


/** @param {!Array<!proto.portal.gloo.solo.io.APIRoute>} value */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.setApiRoutesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.portal.gloo.solo.io.APIRoute=} opt_value
 * @param {number=} opt_index
 * @return {!proto.portal.gloo.solo.io.APIRoute}
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.addApiRoutes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.portal.gloo.solo.io.APIRoute, opt_index);
};


proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.clearApiRoutesList = function() {
  this.setApiRoutesList([]);
};


/**
 * optional int32 number_of_endpoints = 4;
 * @return {number}
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.getNumberOfEndpoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.setNumberOfEndpoints = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional APIType api_type = 5;
 * @return {!proto.portal.gloo.solo.io.APIType}
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.getApiType = function() {
  return /** @type {!proto.portal.gloo.solo.io.APIType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.portal.gloo.solo.io.APIType} value */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.setApiType = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional common.portal.gloo.solo.io.ObjectRef custom_route_table = 7;
 * @return {?proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.getCustomRouteTable = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 7));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectRef|undefined} value */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.setCustomRouteTable = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.clearCustomRouteTable = function() {
  this.setCustomRouteTable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo.prototype.hasCustomRouteTable = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int64 observed_generation = 1;
 * @return {number}
 */
proto.portal.gloo.solo.io.APIProductStatus.prototype.getObservedGeneration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.portal.gloo.solo.io.APIProductStatus.prototype.setObservedGeneration = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional common.portal.gloo.solo.io.State state = 2;
 * @return {!proto.common.portal.gloo.solo.io.State}
 */
proto.portal.gloo.solo.io.APIProductStatus.prototype.getState = function() {
  return /** @type {!proto.common.portal.gloo.solo.io.State} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.common.portal.gloo.solo.io.State} value */
proto.portal.gloo.solo.io.APIProductStatus.prototype.setState = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string reason = 3;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIProductStatus.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIProductStatus.prototype.setReason = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp modified_date = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.portal.gloo.solo.io.APIProductStatus.prototype.getModifiedDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.portal.gloo.solo.io.APIProductStatus.prototype.setModifiedDate = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.portal.gloo.solo.io.APIProductStatus.prototype.clearModifiedDate = function() {
  this.setModifiedDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIProductStatus.prototype.hasModifiedDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * map<string, string> observed_labels = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.portal.gloo.solo.io.APIProductStatus.prototype.getObservedLabelsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


proto.portal.gloo.solo.io.APIProductStatus.prototype.clearObservedLabelsMap = function() {
  this.getObservedLabelsMap().clear();
};


/**
 * map<string, APIProductVersionInfo> version_info = 9;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo>}
 */
proto.portal.gloo.solo.io.APIProductStatus.prototype.getVersionInfoMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo>} */ (
      jspb.Message.getMapField(this, 9, opt_noLazyCreate,
      proto.portal.gloo.solo.io.APIProductStatus.APIProductVersionInfo));
};


proto.portal.gloo.solo.io.APIProductStatus.prototype.clearVersionInfoMap = function() {
  this.getVersionInfoMap().clear();
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.APIRoute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.portal.gloo.solo.io.APIRoute.oneofGroups_);
};
goog.inherits(proto.portal.gloo.solo.io.APIRoute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.APIRoute.displayName = 'proto.portal.gloo.solo.io.APIRoute';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.portal.gloo.solo.io.APIRoute.oneofGroups_ = [[5,8]];

/**
 * @enum {number}
 */
proto.portal.gloo.solo.io.APIRoute.RouteConfigCase = {
  ROUTE_CONFIG_NOT_SET: 0,
  ROUTE: 5,
  ENVIRONMENT_ROUTE: 8
};

/**
 * @return {proto.portal.gloo.solo.io.APIRoute.RouteConfigCase}
 */
proto.portal.gloo.solo.io.APIRoute.prototype.getRouteConfigCase = function() {
  return /** @type {proto.portal.gloo.solo.io.APIRoute.RouteConfigCase} */(jspb.Message.computeOneofCase(this, proto.portal.gloo.solo.io.APIRoute.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.APIRoute.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.APIRoute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.APIRoute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIRoute.toObject = function(includeInstance, msg) {
  var f, obj = {
    operationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    method: jspb.Message.getFieldWithDefault(msg, 2, ""),
    path: jspb.Message.getFieldWithDefault(msg, 3, ""),
    summary: jspb.Message.getFieldWithDefault(msg, 4, ""),
    route: (f = msg.getRoute()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_route_pb.RouteSpec.toObject(includeInstance, f),
    environmentRoute: jspb.Message.getFieldWithDefault(msg, 8, ""),
    isgrpc: jspb.Message.getFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.APIRoute}
 */
proto.portal.gloo.solo.io.APIRoute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.APIRoute;
  return proto.portal.gloo.solo.io.APIRoute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.APIRoute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.APIRoute}
 */
proto.portal.gloo.solo.io.APIRoute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethod(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 5:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_route_pb.RouteSpec;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_route_pb.RouteSpec.deserializeBinaryFromReader);
      msg.setRoute(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnvironmentRoute(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsgrpc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.APIRoute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.APIRoute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.APIRoute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.APIRoute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMethod();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRoute();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_route_pb.RouteSpec.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIsgrpc();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string operation_id = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIRoute.prototype.getOperationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIRoute.prototype.setOperationId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string method = 2;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIRoute.prototype.getMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIRoute.prototype.setMethod = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string path = 3;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIRoute.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIRoute.prototype.setPath = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string summary = 4;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIRoute.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIRoute.prototype.setSummary = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional RouteSpec route = 5;
 * @return {?proto.portal.gloo.solo.io.RouteSpec}
 */
proto.portal.gloo.solo.io.APIRoute.prototype.getRoute = function() {
  return /** @type{?proto.portal.gloo.solo.io.RouteSpec} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_route_pb.RouteSpec, 5));
};


/** @param {?proto.portal.gloo.solo.io.RouteSpec|undefined} value */
proto.portal.gloo.solo.io.APIRoute.prototype.setRoute = function(value) {
  jspb.Message.setOneofWrapperField(this, 5, proto.portal.gloo.solo.io.APIRoute.oneofGroups_[0], value);
};


proto.portal.gloo.solo.io.APIRoute.prototype.clearRoute = function() {
  this.setRoute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIRoute.prototype.hasRoute = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string environment_route = 8;
 * @return {string}
 */
proto.portal.gloo.solo.io.APIRoute.prototype.getEnvironmentRoute = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.APIRoute.prototype.setEnvironmentRoute = function(value) {
  jspb.Message.setOneofField(this, 8, proto.portal.gloo.solo.io.APIRoute.oneofGroups_[0], value);
};


proto.portal.gloo.solo.io.APIRoute.prototype.clearEnvironmentRoute = function() {
  jspb.Message.setOneofField(this, 8, proto.portal.gloo.solo.io.APIRoute.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.APIRoute.prototype.hasEnvironmentRoute = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool isGrpc = 7;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.portal.gloo.solo.io.APIRoute.prototype.getIsgrpc = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 7, false));
};


/** @param {boolean} value */
proto.portal.gloo.solo.io.APIRoute.prototype.setIsgrpc = function(value) {
  jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * @enum {number}
 */
proto.portal.gloo.solo.io.APIType = {
  EMPTY: 0,
  OPEN_API: 1,
  GRPC: 2,
  HYBRID: 3
};

goog.object.extend(exports, proto.portal.gloo.solo.io);
